import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Divider,
} from "@mui/material";
import logo from "../../../assets/logo.svg";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

const PreviewInvoice = ({ invoiceDetails, branchDetails }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const year = String(date.getFullYear()).slice(-2); // last two digits
    return `${day}-${month}-${year}`;
  };
  function getDayName(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { weekday: "long" });
  }

  return (
    <Box width={"60%"} mx="auto" p={3}>
      <Typography variant="h6" align="center" fontWeight="bold">
        INVOICE
      </Typography>
      <Grid container spacing={2} mt={4}>
        <Grid size={8}>
          <Box>
            <img
              src={logo}
              alt="Logo"
              style={{ width: "100px", height: "auto" }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid size={8}>
          <Box>
            <Typography variant="body2" className="previewincoice_text">
              {branchDetails?.name}
            </Typography>
            <Typography variant="body2" className="previewincoice_text">
              {branchDetails?.address + " " + branchDetails?.country}
            </Typography>
            <Typography variant="body2" className="previewincoice_text">
              {branchDetails?.city + " - " + branchDetails?.postal_code}
            </Typography>
            <Typography variant="body2" className="previewincoice_text">
              {branchDetails?.contact_number}
            </Typography>
          </Box>
        </Grid>

        <Grid size={4}>
          <Box>
            <Typography className="previewinvoice_text2">
              <strong>Date</strong>: {formatDate(new Date())}
            </Typography>
            <Typography className="previewinvoice_text2">
              {" "}
              <strong>Attended Slots</strong>:{" "}
              {invoiceDetails?.sessions
                .map((s) => s)
                .filter((s) => s.attended === true)
                .length.toString()
                .padStart(2, "0")}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="invoicetablecell-text">
                <strong>Service</strong>
              </TableCell>
              <TableCell className="invoicetablecell-text">
                <strong>Day</strong>
              </TableCell>
              <TableCell className="invoicetablecell-text">
                <strong>Date</strong>
              </TableCell>
              <TableCell className="invoicetablecell-text">
                <strong>Total</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(invoiceDetails?.sessions) &&
              invoiceDetails?.sessions.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell className="tablebody-text">
                    {row.service_name}
                  </TableCell>
                  <TableCell className="tablebody-text">
                    {getDayName(row.session_date)}
                  </TableCell>
                  <TableCell className="tablebody-text">
                    {formatDate(row.session_date)}
                  </TableCell>
                  <TableCell className="tablebody-text">
                    {row.therapy_fee}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={3} textAlign="right">
        <Typography>
          Sub Total Amount: {invoiceDetails?.total_amount}
        </Typography>
        <Typography>Discount: 0</Typography>
        <Divider sx={{ my: 1 }} />
        <Typography
          variant="h6"
          fontWeight="bold"
          color="blue"
          className="font"
        >
          <span className="total_row">
            Total:
            <CurrencyRupeeIcon className="rupee_icon" />
            {invoiceDetails?.total_amount}
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default PreviewInvoice;
